<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="content-div">
      <div class="visualDevelopment">
        <div class="content-title">可视化开发</div>
        <div class="content-desc">轻骑兵低代码PaaS平台提供基于拖拽配置式的可视化页面、流程设计器，提供了一系列可扩展组件库、自定义组件库、页面模板库、公共样式库等资源库，支持用户通过“拖拉拽+简单配置”的方式，完成多种复杂场景下的原型绘制、功能开发、数据库设计、流程设计、移动开发等工作。</div>
        <div class="visualDevelopment-img-div">
          <img class="visualDevelopment-img" src="../assets/img/homePage/function1.gif"/>
        </div>
      </div>
      <div class="aiAbility">
        <div class="content-title">AI能力</div>
        <div class="content-desc">轻骑兵低代码PaaS平台基于ChatGLM大模型，实现可视化开发过程中的模块、表单、字段等智能推荐的功能，易用性和开发效率进一步提升，具有低成本部署，性能高的特点。</div>
        <img class="aiAbility-img1" src="../assets/img/keyFeaturesPhone/aiAbility-img1.png">
        <img class="aiAbility-img2" src="../assets/img/keyFeaturesPhone/aiAbility-img2.png">
        <img class="aiAbility-img3" src="../assets/img/keyFeaturesPhone/aiAbility-img3.png">
        <img class="aiAbility-img4" src="../assets/img/keyFeaturesPhone/aiAbility-img4.png">
      </div>
      <div class="comprehensive">
        <div class="content-title">全面信创</div>
        <div class="content-desc">轻骑兵低代码PaaS平台支持信创，全面兼容了国产化软硬件生态体系，包括国产化服务器、操作系统、数据库、中间件等，信息安全可控。</div>
        <img src="../assets/img/keyFeaturesPhone/comprehensive-img.png">
      </div>
      <div class="expand">
        <div class="content-title">灵活拓展</div>
        <div class="content-desc">轻骑兵低代码PaaS平台提供了公式编辑、在线脚本编辑、外部资源注册和代码全解析4种二次开发扩展方式，实现复杂业务场景的开发。</div>
        <div class="expand-video-div">
          <video src="../assets/video/expend1.mp4" controls="true"/>
        </div>
      </div>
      <div class="security">
        <div class="content-title">安全可靠</div>
        <div class="content-desc">轻骑兵低代码PaaS平台具有高安全性的平台架构。轻骑兵参照《国家信息安全等级保护管理办法》进行设计建设，符合安全测试8个大项126个小项，其中的8个大项包括：标识和鉴别、数据保密性、数据完整性、外部接口、会话管理、安全审计、访问控制、软件容错，同时轻骑兵融合了大型网站系统安全的设计经验以及传统管理系统的安全手段，在防攻击、防注入、安全加密等方面进行了安全加固，保证了系统的数据存储安全、传输安全。</div>
        <img src="../assets/img/keyFeaturesPhone/security-img.png">
      </div>
      <div class="singleService">
        <div class="content-title">单体/微服务架构</div>
        <div class="content-desc">轻骑兵低代码PaaS平台提供单体与微服务架构两种开发模式，支持从单体架构直接切换到微服务架构。平台提供全套的微服务相关服务支撑，能够快速搭建微服务应用。</div>
        <img src="../assets/img/keyFeaturesPhone/singleService-img.png">
      </div>
      <!-- 底部公司信息 -->
      <CompanyInformation @changePracticeMenuShow="handleOpenPractice"></CompanyInformation>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>

import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import ExperienceNow from "./include/ExperienceNow";
import CompanyInformation from "./include/CompanyInformation";
export default {
  name: "KeyFeaturesPhone",
  components: {
    PhoneFooter,
    PhoneHeader,
    RightMenu,
    ExperienceNow,
    CompanyInformation
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
    };
  },
  methods: {
    // 了解更多
    handleRouter() {
      this.$router.push("/CasePhonePage");
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  }
};
</script>

<style scoped>
/* 头部 */
.content-div {width: 100%;margin-top: 52px;}
.content-title{padding: 40px 10px 10px 10px;font-size: 22px;font-weight: bold;text-align: center}
.content-desc{padding: 10px 15px 20px 15px;font-size: 14px;text-align: justify;line-height: 23px}

.visualDevelopment{background: url("../assets/img/keyFeaturesPhone/visualDevelopment-bg.png") no-repeat;background-size: 100% 100%;padding-bottom: 35px}
.visualDevelopment-img-div{border: 1px solid #fff;border-radius: 3px;background: #BBD5F8;text-align: center;width: 92%;margin: auto;}
.visualDevelopment-img-div img{margin: 5px;width: 97%;}

.aiAbility{background: url("../assets/img/keyFeaturesPhone/aiAbility-bg.png") no-repeat;background-size: 100% 100%;padding-bottom: 35px;text-align: center}
.aiAbility-img1{width: 93%;margin-top: 30px}
.aiAbility-img2{width: 50%;margin-right: 3%;position: relative;top: -20px}
.aiAbility-img3{width: 40%;position: relative;top: -45px}
.aiAbility-img4{width: 22%;position: absolute;top: 630px;left: 290px}

.comprehensive{background: url("../assets/img/keyFeaturesPhone/comprehensive-bg.png") no-repeat;background-size: 100% 100%;padding-bottom: 35px;text-align: center}
.comprehensive img{width: 90%}

.expand{background: url("../assets/img/keyFeaturesPhone/expand-bg.png") no-repeat;background-size: 100% 100%;padding-bottom: 35px}
.expand-video-div{border: 1px solid #fff;border-radius: 3px;background: #BBD5F8;text-align: center;width: 95%;margin: auto;}
.expand-video-div video{margin: 4px;width: 97%;}

.security{background: url("../assets/img/keyFeaturesPhone/security-bg.png") no-repeat;background-size: 100% 100%;padding-bottom: 35px;text-align: center}
.security img{width: 95%}

.singleService{padding-bottom: 35px;text-align: center}
.singleService img{width: 95%}
</style>



// WEBPACK FOOTER //
// src/components/KeyFeaturesPhone.vue